<section class="main-layout">
  <section>
    <h1 class="text-title" [ngClass]="{ 'height-title': !detail.name }">{{ detail.name }}</h1>
    <h1 class="text-title">{{ detail.detail }}</h1>
    <h2 class="text-sub">กรุณากรอกข้อมูลเพื่อรับโค้ดส่วนลด</h2>
    <div [ngClass]="{ 'height-title': !detail.detail }"></div>
  </section>
  <!-- <section class="layout-ecoupon"> -->
  <!-- <form action=""> -->
  <form #myForm="ngForm" class="ecoupon-form" (submit)="onClick(myForm, $event)">
    <fieldset class="ecoupon-form">
      <div class="ecoupon-form">
        <label for="name">ชื่อ</label>
        <mat-form-field class="bg-white">
          <input
            matInput
            type="text"
            id="firstname"
            name="firstname"
            placeholder="ชื่อ"
            [(ngModel)]="eCouponForm().firstname"
            pattern="^[a-zA-Zก-๙ ]+$"
            (keypress)="validateInput($event)"
            required
          />
          <mat-error>
            กรุณากรอก
            <strong>ชื่อ</strong>
          </mat-error>
        </mat-form-field>
        <label for="lastname">นามสกุล</label>
        <mat-form-field class="bg-white">
          <input
            id="lastname"
            name="lastname"
            matInput
            placeholder="นามสกุล"
            [(ngModel)]="eCouponForm().lastname"
            pattern="^[a-zA-Zก-๙ ]+$"
            (keypress)="validateInput($event)"
            required
          />
          <mat-error>
            กรุณากรอก
            <strong>นามสกุล</strong>
          </mat-error>
        </mat-form-field>
        <label for="mobile">เบอร์โทร</label>
        <mat-form-field class="bg-white">
          <input
            id="mobile"
            name="mobile"
            maxlength="10"
            matInput
            placeholder="เบอร์โทร"
            [(ngModel)]="eCouponForm().mobile"
            #mobile="ngModel"
            pattern="^0[0-9]{9}$"
            (keypress)="allowOnlyNumbers($event)"
            required
          />
          <!-- เบอร์โทรว่าง -->
          @if (mobile.errors?.['required'] && mobile.touched) {
          <mat-error>
            กรุณากรอก
            <strong>เบอร์โทร</strong>
          </mat-error>
          }

          <!-- เบอร์โทรผิด pattern -->
          @if (mobile.errors?.['pattern'] && mobile.touched) {
          <mat-error>
            กรุณากรอก
            <strong>เบอร์โทรให้ถูกต้อง</strong>
          </mat-error>
          }
        </mat-form-field>

        <label for="car_license">ทะเบียนรถ (ตัวอย่าง : กค1234)</label>
        <mat-form-field class="bg-white">
          <input
            id="car_license"
            name="car_license"
            type="text"
            matInput
            placeholder="ทะเบียนรถ"
            [(ngModel)]="eCouponForm().car_license"
            pattern="^[a-zA-Z0-9ก-๙]+$"
            required
            #carLicense="ngModel"
          />
          <!-- ถ้าไม่กรอก -->
          @if (carLicense.errors?.['required'] && carLicense.touched) {
          <mat-error>
            กรุณากรอก
            <strong>ทะเบียนรถ</strong>
          </mat-error>
          }
          <!-- ถ้ากรอกแต่ pattern ผิด -->
          @if (carLicense.errors?.['pattern'] && carLicense.touched) {
          <mat-error>
            กรุณากรอก
            <strong>ทะเบียนรถให้ถูกต้อง</strong>
          </mat-error>
          }
        </mat-form-field>
        <label for="car_province">จังหวัดรถ</label>
        <mat-form-field>
          <mat-label for="car_province">จังหวัดรถ</mat-label>
          <mat-select id="car_province" name="car_province" matNativeControl [(ngModel)]="eCouponForm().car_province" required>
            @for (province of provinceListSignal(); track province) {
            <mat-option [value]="province.name_th">{{ province.name_th }}</mat-option>

            }
          </mat-select>
          <mat-error>
            กรุณาเลือก
            <strong>จังหวัดรถ</strong>
          </mat-error>
        </mat-form-field>

        <!-- <label for="code">โค้ดลับ</label>
        <mat-form-field class="bg-white">
          <input matInput type="text" id="code" name="code" placeholder="โค้ดลับ" [(ngModel)]="eCouponForm().code"
            pattern="{{codeCampaign}}" required />
          <mat-error>
            กรุณากรอก
            <strong>โค้ดลับ</strong>
          </mat-error>
        </mat-form-field> -->
      </div>
      <!-- @if(){ -->
      <span class="text-warning">{{ errorMessage }}</span>
      <!-- } @else{ -->
      <!-- หมายเลขโทรศัพท์ และ ทะเบียนรถคันนี้ได้รับสิทธิครบตามจำนวนที่กำหนดแล้ว -->
      <!-- <span class="text-warning">หมายเลขโทรศัพท์ ได้รับสิทธิครบตามจำนวนที่กำหนดแล้ว</span> -->
      <!-- }  -->
      <p>
        การกดปุ่ม "ตกลง" ด้านล่างนี้ ถือว่าท่านตกลงรับสิทธิตามเงื่อนไขด้านบน และรับทราบการประมวลผลข้อมูลส่วนบุคคลตาม
        <span
          role="button"
          tabindex="0"
          class="privacy-link"
          (click)="openDialogAnnounce()"
          (keydown.enter)="openDialogAnnounce()"
          (keydown.space)="openDialogAnnounce()"
        >
          ประกาศความเป็นส่วนตัวสำหรับการลงทะเบียนรับส่วนลด
        </span>
      </p>

      <button mat-flat-button style="transform: skewX(-10deg)" type="submit">ตกลง</button>
    </fieldset>
  </form>

  <!-- </form> -->
  <!-- </section> -->

  <!-- <pre> {{provinceListSignal() | json}}</pre> -->
</section>
